import { c as _c } from "react/compiler-runtime";
import HalfLayout from '@/components/layouts/half-layout';
import { ScreenFitText } from '@/components/ui/screen-fit-text';
const ServiceHeader = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <HalfLayout.LeftChild><div /></HalfLayout.LeftChild>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ScreenFitText text="Designed for brands" className="font-primary font-black text-neutral-300" />;
    t2 = <ScreenFitText text="That are ready to scale" className="font-primary font-black text-neutral-100" />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="pb-24 lg:pt-24"><HalfLayout>{t0}<HalfLayout.RightChild>{t1}{t2}<p className="mt-9 text-xl font-medium text-neutral-300 lg:text-lg">Whether you're building authority or optimizing an established business, our packages are structured around growth, trust, and{" "}<span className="decoration-accent/15 underline decoration-1 underline-offset-8">long-term revenue</span>.</p></HalfLayout.RightChild></HalfLayout></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default ServiceHeader;